module.exports = __webpack_public_path__ + "static/img/P4.b14ec62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hjzs/P4.png
// module id = h/SA
// module chunks = 0